import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { CompanyInfo } from '../_shared/models/company-info.model';
import { Footer, IFooterContent } from '../_shared/models/footer.model';
import { SocialMediaItem } from '../_shared/models/social-media-links.model';
import { Subject } from 'rxjs';
import { LinkService } from '../_shared/services/link.service';
import { ILink } from '../_shared/models/link.model';
import { SocialMediaIconService } from '../_shared/services/social-media-icon.service';
import { GtmService } from '../_shared/services/gtm.service';
import { SnowplowService } from '../_shared/services/snowplow.service';
import { TrackingEvents } from '../_shared/data/tracking-events.data';
import { ICustomWindow, WindowRefService } from '../_shared/services/window-ref.service';
import { GridComponent } from '../grid/grid.component';
import { IconComponent } from '../icon/icon.component';

import { TranslateModule } from '@ngx-translate/core';
import { LinkDirective } from '../_shared/directives/link.directive';

@Component({
    selector: 'sirius-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'sir-text-style-paragraph-m-default sir-text-context-on-dark' },
    imports: [GridComponent, IconComponent, LinkDirective, TranslateModule]
})
export class FooterComponent implements OnInit {
    private _socialMediaIconService = inject(SocialMediaIconService);
    private _gtmService = inject(GtmService);
    private _snowplowService = inject(SnowplowService);
    private _linkService = inject(LinkService);
    private _windowRef = inject(WindowRefService);

    @Input() content?: IFooterContent;
    @Input() footer?: Footer;
    @Input() companyInfo?: CompanyInfo;
    @Input() socialMediaLinks: SocialMediaItem[] = [];

    config = {};
    currentYear = new Date().getFullYear();

    private _select = new Subject<{ link: ILink; anchor: HTMLElement }>();

    private get Window(): ICustomWindow | undefined {
        return this._windowRef.NativeWindow;
    }

    ngOnInit(): void {
        if (this.content) {
            this.footer = this.content.footer;
            this.companyInfo = this.content.companyInfo;
            this.socialMediaLinks = this.content.socialMediaLinks;

            this.socialMediaLinks.forEach(
                (x: SocialMediaItem) =>
                    (x.icon = this._socialMediaIconService.getIconName(x.itemType))
            );
        }

        this.addTracking();
    }

    onClick(item: { link: ILink; event: Event }) {
        const tar = item.event.target as HTMLElement;

        this._select.next({ link: item.link, anchor: tar });
    }

    //#region tracking
    addTracking(): void {
        if (!this.Window) {
            return;
        }

        this._select.subscribe((x: { link: ILink; anchor: HTMLElement }) => {
            const data = this._linkService.getTrackingData(x.anchor);

            const cfg = {
                ...x.link.tracking?.parameters,
                link_classes: data.linkClasses,
                link_id: data.linkId,
                link_text: data.linkText,
                link_url: data.linkUrl,
                outbound: data.outbound,
            };

            this._gtmService.track(TrackingEvents.gtm['footerClick']([cfg]));

            const cfg2 = {
                category: 'footer',
                identifier: x.link.tracking?.parameters['identifier'],
                element_classes: data.linkClasses.split(' '),
                target_url: data.linkUrl ? data.linkUrl : this.Window?.location.href,
                element_content: data.linkText,
                outbound: data.outbound !== 'FALSE',

                context: [],
            };

            this._snowplowService.track('linkClick', cfg2);
        });
    }
    //#endregion
}
